import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // detect user language
  .use(LanguageDetector)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    // resources: {
    //   en: {
    //     translation: {
    //       "welcome_to_relaxation_laboratory": "Welcome to Relaxation Laboratory"
    //     }
    //   },
    //   de: {
    //     translation: {
    //       "welcome_to_relaxation_laboratory": "Willkommen im Entspannungslabor"
    //     }
    //   }
    // },
    supportedLngs: ["de", "en"],
    // lng: "de",
    // fallbackLng: "en",
    // Options for language detector
    detection: {
      order: ["cookie", "htmlTag", "localStorage", "path", "subdomain"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: "/assets/locales/{{lng}}/translation.json",
      allowMultiLoading: false,
    },
    // react: {
    //   useSuspense: false,
    // },
  });

// function App() {
//   const { t } = useTranslation();

//   return <h2>{t("welcome_to_relaxation_laboratory")}</h2>;
// }

export default i18n;